import { useState } from 'react'

import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { GOOGLE_MAP_API_KEY } from '@/utils/config'
import useDebounceValue from '@/utils/hooks/useDebounce'

const GOOGLE_REVERSE_GEOCODE_PATH = `https://maps.googleapis.com/maps/api/geocode/json?address=
                              {address}&key=${GOOGLE_MAP_API_KEY}`

export const useGeoLocation = (address) => {
  const [error, setError] = useState(false)
  const [noResults, setNoResults] = useState(false)
  const { debouncedValue: debouncedAddress } = useDebounceValue(address, 500)

  const { data, isLoading } = useQuery({
    queryKey: ['get-geo-location', debouncedAddress],
    queryFn: async () => {
      setError(false)
      setNoResults(false)
      if (!debouncedAddress) {
        setError(true)
        return false
      }
      try {
        const response = await axios.get(
          GOOGLE_REVERSE_GEOCODE_PATH.replace('{address}', debouncedAddress),
        )
        if (response.data.status === 'ZERO_RESULTS') {
          setNoResults(true)
          return false
        }
        return response.data?.results?.[0].geometry.location
      } catch (e) {
        setError(false)
        return false
      }
    },
    staleTime: Infinity,
  })
  return { location: data, loading: isLoading, error, noResults }
}

export default useGeoLocation
